import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _CheckSessionRequestDtoSchema = z.object();

const CheckSessionResponseDtoSchema = z.object({
  accessToken: z.string().optional(),
  isValid: z.boolean(),
});

export type CheckSessionRequestDto = z.infer<
  typeof _CheckSessionRequestDtoSchema
>;
export type CheckSessionResponseDto = z.infer<
  typeof CheckSessionResponseDtoSchema
>;

export const checkSession = (
  config?: AxiosRequestConfig<CheckSessionRequestDto>
) => {
  return api
    .get('/auth/check-session', config)
    .then(responseContract(CheckSessionResponseDtoSchema));
};
